import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import { Asset } from '@mux/mux-node';

interface mediaState {
  value: Media[];
  isLoading: boolean;
  error: string;
}

const initialState: mediaState = {
  value: [],
  isLoading: false,
  error: '',
};

export const mediaSlice = createSlice({
  name: 'media',
  initialState,
  reducers: {
    setMedias(state, action: PayloadAction<Media[]>) {
      const medias = action.payload;
      state.value = medias;
    },
    addMedia(state, action: PayloadAction<Media>) {
      const media = action.payload;
      state.value.push(media);
    },

    getMediaRequested(state, action: PayloadAction<{ projectId: number }>) {
      state.isLoading = true;
      state.value = [];
    },
    getMediaSucceeded(state, action: PayloadAction<Media[]>) {
      const medias = action.payload;
      state.value = medias;
    },
    getMediaFailed(state, action: PayloadAction<SagaError>) {
      const { message } = action.payload;
      state.error = message;
    },

    createMediaRequested(state, action: PayloadAction<{ media: Media; projectId: number }>) {
      state.isLoading = true;
    },
    createMediaSucceeded(state, action: PayloadAction<Media>) {
      const media = action.payload;
      state.value.push(media);
    },
    createMediaFailed(state, action: PayloadAction<SagaError>) {
      const { message } = action.payload;
      state.error = message;
    },
  },
});

export default mediaSlice.reducer;
export const {
  setMedias,
  addMedia,
  getMediaRequested,
  getMediaSucceeded,
  getMediaFailed,
  createMediaRequested,
  createMediaSucceeded,
  createMediaFailed,
} = mediaSlice.actions;
